<template>
    <q-submenu :base-url="baseUrl" :title="title" :buttons="buttons" class="q-sticky"></q-submenu>
</template>
<script>
//table data + search
import QSubmenu from '@/components/navigation/Submenus/QSubmenu.vue'
export default {
    name: 'QPopupSubmenu',
    data() {
        return {
            title: "Messages",
            baseUrl: '/admin/sent-messages/',
        }
    },
    computed: {
        buttons() {
            return [
                {
                    label: "Messages Inbox",
                    to: { name: 'Notices' },
                    icon: "fas fa-arrow-alt-circle-down",
                },
                this.hasRole(['SuperAdmin', 'AgencyOwner', "Exec", 'Staff']) && this.notRole(['SalesRep', 'UnlicensedAgent']) && {
                    label: "Sent Messages",
                    to: { name: 'PopupNoticeAdmin' },
                    icon: "fas fa-arrow-alt-circle-down",
                },
            ].filter(Boolean)
        }
    },
    components: {
        QSubmenu
    },
    methods: {},
}

</script>
<style>
</style>
